import React from 'react';
import starFullIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Star-Full-Icon.svg';
import starHalfIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Star-Half-Icon.svg';
import starEmptyIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Star-Empty-Icon.svg';

type StarsRatingProps = {
    rating: number;
};
export default function OnlyStars(props: StarsRatingProps) {
    const { rating } = props;
    const stars = [];
    let hasRating = true;

    for (let i = 1; i < 6; i++) {
        if (i <= rating) {
            hasRating = true;
            stars.push(
                <img width={30} key={`star_${i}`} src={starFullIcon} alt='' />
            );
        } else {
            const currentFloor = Math.floor(rating);
            const projectedFloor = Math.floor(rating - 0.5);
            if (projectedFloor === currentFloor && i === currentFloor + 1) {
                stars.push(
                    <img
                        width={30}
                        key={`star_${i}`}
                        src={starHalfIcon}
                        alt=''
                    />
                );
            } else {
                stars.push(
                    <img
                        width={30}
                        key={`star_${i}`}
                        src={starEmptyIcon}
                        alt=''
                    />
                );
            }
        }
    }
    return hasRating ? stars.map((star) => star) : <></>;
}
